import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './setupAxios';
import { PwaInstallProvider } from './hooks/PwaInstallContext';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Provider store={store}>
      <PwaInstallProvider>
        <App />
      </PwaInstallProvider>
    </Provider>
  </BrowserRouter>
);

// ----------------- SERVICE WORKER -----------------
(async () => {
  const host = window.location.hostname;
  const isDevDomain = host === 'dev.angelsonwatch.com';
  const DISABLE_SW = String(process.env.REACT_APP_DISABLE_SW || '').trim() === '1';

  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (isDevDomain || DISABLE_SW) {
    // DEV/forzado: desregistrar cualquier SW y limpiar caches para evitar bundles viejos
    try {
      await serviceWorkerRegistration.unregister();
    } catch {}

    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    } catch {}

    try {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    } catch {}

    // Recarga una única vez tras limpiar (por sesión)
    if (!sessionStorage.getItem('aow_sw_cleared')) {
      sessionStorage.setItem('aow_sw_cleared', '1');
      window.location.reload();
    }
    return;
  }

  // Escuchar cuando un nuevo SW toma el control para recargar la app limpia
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });

  // PRODUCCIÓN / otros entornos: registro normal con auto-actualización
  serviceWorkerRegistration.register({
    onSuccess: () => {},
    onUpdate: async (registration) => {
      try {
        if (registration && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          setTimeout(() => window.location.reload(), 300);
        }
      } catch {
        window.location.reload();
      }
    },
  });
})();
